import { httpMethods } from 'enums';
import { Http } from 'library';
import api from 'api/client';

import axios from 'axios';

class PartnerPayment {
  static getAmountDetails = async (data) => {
    return Http.setMethod(httpMethods.get)
      .setUrl(`/payment/order/details/${data}`)
      .setToken(api.getToken())
      .request();
  };

  static paymentUpdate = async (data) => {
    return Http.setMethod(httpMethods.post)
      .unsetData()
      .setUrl(`/partner/payment-update`)
      .setData(data)
      .setToken(api.getToken())
      .request();
  };
}
export default PartnerPayment;
